import { useDarkModeContext } from "@/contexts/DarkModeContext";

type ThemePreference = "light" | "dark";

interface UseDarkModeReturn {
  isDark: boolean;
  toggleDarkMode: () => void;
  setTheme: (theme: ThemePreference) => void;
}

/**
 * Hook to access shared dark mode state from context.
 * Theme state is shared across all consumers.
 * 
 * - Light theme is the default for first-time users
 * - Theme persists in localStorage for unauthenticated users
 * - Theme syncs to user profile for authenticated users
 */
export const useDarkMode = (): UseDarkModeReturn => {
  return useDarkModeContext();
};
